import { useId, type ComponentProps } from 'react';
import { Icon } from '@plone/components';

const LinkedInSVG = (props: Omit<ComponentProps<typeof Icon>, 'children'>) => {
  const pathId = useId();

  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <defs>
          <clipPath id={pathId}>
            <path fill="none" d="M5.52 5.8h16.59v16.39H5.52z" />
          </clipPath>
        </defs>
        <path d="M5.67 10.79H9V22.2H5.67z" fill="currentColor" />
        <g clip-path={`url(#${pathId})`}>
          <path
            d="M7.34 5.8c-1.01 0-1.82.82-1.82 1.82s.82 1.82 1.82 1.82 1.82-.82 1.82-1.82S8.34 5.8 7.34 5.8M19.38 10.75c-3.1-.87-4.74 1.22-4.74 1.22l-.41-1.51h-3.05V22.2h3.57v-6.96c0-1.04.84-1.88 1.88-1.88s1.88.84 1.88 1.88v6.96h3.57v-5.87s.4-4.71-2.71-5.58"
            fill="currentColor"
          />
        </g>
      </svg>
    </Icon>
  );
};

export default LinkedInSVG;
